import { gql } from '@apollo/client';

import { EscrowMembershipFragment } from './escrowMemberships.fragment';

export * from './escrowMemberships.query.generated';

export const ESCROW_MEMBERSHIPS = gql`
  ${EscrowMembershipFragment}
  query escrowMemberships(
    $beneficiaryId: ID!
    $orderBy: EscrowMembershipsOrderByEnum
    $order: QueryOrderEnum
    $page: Int
    $perPage: Int
    $query: String
  ) {
    escrowMemberships(
      beneficiaryId: $beneficiaryId
      orderBy: $orderBy
      order: $order
      page: $page
      perPage: $perPage
      query: $query
    ) {
      nodes {
        ...EscrowMembershipFragment
      }
      pagesCount
      nodesCount
      hasNextPage
      hasPreviousPage
    }
  }
`;
